import React, { useState, useCallback, useMemo, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Button from "../../../../components/buttons/buttons";
import { Beat } from "../../../../plugins/spinners.plugin";
// import Warning from "../../../../assets/images/icons/warning-circle.svg";
import PaymentModalCart from "../../../../components/modals/payment/paymentModalCart";
import ShareOrderModal from "../../../../components/modals/payment/shareOrderModal";
// import { PriceNoticeModal } from "../../../../components/modals/payment/PriceNotice";
// import { ServiceAreaNoticeModal } from "../../../../components/modals/payment/ServiceAreaNotice";
import { SignUpModal } from "../../../../components/modals/auth/signUpModal";
import { AddressModal } from "../../../../components/modals/address/addressModal";
import { checkoutCart, showMyCart } from "../../../../redux/cart/cartAction";
import {
  isAuthenticatedUser,
  getUserFromStorage,
} from "../../../../utils/Auth";
// import { updateAnAddressAction } from "../../../../redux/address/addressActions";
import { validateCart } from '../../../../redux/cart/cartAction';

function numberWithCommas(x) {
  return x?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export default function Checkout({ myCart, currentAddress, currentShipper, onOpenShipperModal }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = getUserFromStorage();
  const isAuth = isAuthenticatedUser();
  const paymentModalRef = useRef(null);
  const shareOrderModalRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  // const [openNotice, setOpenNotice] = useState(false);
  // const [serviceNotice, setServiceNotice] = useState(false);
  const [loadingPfm, setLoadingPfm] = useState(false);
  // const [deliveryNotes, setDeliveryNotes] = useState("");

  const data = useMemo(
    () => ({
      user_id: user?.id,
      order_type: "standard",
    }),
    [user]
  );

  const { processing } = useSelector((state) => state.cart);
  const { setShipper } = useSelector((state) => state.publicShippers);

  function closeModal() {
    setIsOpen(false);
  }
  function openModal() {
    setIsOpen(true);
  }

  // const handleChangeDeliveryNotes = async (e) => {
  //   e.preventDefault();
  //   const { value } = e?.target;
  //   setDeliveryNotes(value);
  // };

  // const handleAddressDeliveryNotes = async (e) => {
  //   if (currentAddress.length > 0 && deliveryNotes.length > 3) {
  //     await dispatch(
  //       updateAnAddressAction({
  //         id: currentAddress?.[0]?.id,
  //         description: deliveryNotes,
  //       })
  //     );
  //   }
  // };

  const goToGuestCheckout = () => {
    if (setShipper?.id) {
      navigate(`/cart/guest-checkout?shipperId=${setShipper?.id}`);
    }
  };

  const handleSubmit = useCallback(async () => {
    //validate the cart before opening the payment modal
    await dispatch(validateCart());
    if (currentAddress.length > 0) {
      paymentModalRef.current.open();
      paymentModalRef.current.getSelectedShipper(currentShipper);
    }
    // eslint-disable-next-line
  }, [currentAddress, currentShipper]);

  const handleSubmitShare = useCallback(async () => {
    if (currentAddress.length > 0) {
      setLoadingPfm(true);
      const response = await dispatch(
        checkoutCart({
          ...data,
          user_id: user?.id,
          payment_type: "collect",
          shipper_id: currentShipper?.id,
        })
      );
      setLoadingPfm(false);
      if (response.status === "success") {
        setLoadingPfm(false);
        dispatch(showMyCart());
        shareOrderModalRef.current.open();
        shareOrderModalRef.current.getPfm(response?.data?.pfm);
      } else {
        setLoadingPfm(false);
      }
    }
  }, [currentAddress, currentShipper, data, dispatch, user]);

  return (
    <div className="grid grid-cols-1 gap-4 h-full">
      <section
        aria-labelledby="section-2-title"
        className="h-full flex flex-col justify-between"
      >
        <h2 className="sr-only" id="section-2-title">
          Section title
        </h2>
        <div>
          <div className="rounded-xl bg-white dark:bg-[#121212] overflow-hidden shadow-lg">
            <div className="p-6">
              <h3 className="text-xl font-medium mb-10">
                Pricing including VAT
              </h3>

              <div className="mb-5">
                <div className="flex justify-between items-center mb-4">
                  <label>Subtotal:</label>
                  <span className="dark:text-[#BCBCBC]">
                    ₦{numberWithCommas(myCart?.sub_amount) ?? 0}
                  </span>
                </div>
                <div className="flex justify-between items-center mb-4">
                  <label>Service fee:</label>
                  <span className="dark:text-[#BCBCBC]">
                    ₦{numberWithCommas(myCart?.service_fee) ?? 0}
                  </span>
                </div>
                <div className="flex justify-between items-center mb-4">
                  <label>Delivery fee:</label>
                  <span className="dark:text-[#BCBCBC]">
                    ₦{numberWithCommas(myCart?.delivery_fee) ?? 0}
                  </span>
                </div>
                <div className="flex justify-between items-center mb-4">
                  <label>Insurance fee:</label>
                  <span className="dark:text-[#BCBCBC]">
                    ₦{numberWithCommas(myCart?.insurance_fee) ?? 0}
                  </span>
                </div>
                <div className="flex justify-between items-center mb-4">
                  <label>Discount:</label>
                  <span className="dark:text-[#BCBCBC]">
                    ₦{numberWithCommas(myCart?.discount) ?? 0}
                  </span>
                </div>
                <div className="flex justify-between items-center mb-4">
                  <label>Tax fee:</label>
                  <span className="dark:text-[#BCBCBC]">
                    ₦{numberWithCommas(myCart?.tax_fee) ?? 0}
                  </span>
                </div>
                <div className="flex justify-between items-center mb-4">
                  <label>Handling fee:</label>
                  <span className="dark:text-[#BCBCBC]">
                    ₦{numberWithCommas(myCart?.handling_fee) ?? 0}
                  </span>
                </div>
                <div className="flex justify-between items-center mb-4">
                  <label>Total:</label>
                  <span className="font-bold">
                    ₦{numberWithCommas(myCart?.amount?.toFixed(2)) ?? 0}
                  </span>
                </div>
              </div>

              {/* Check if there are items in cart but no shipper selected */}
              {(myCart?.products?.length > 0 || myCart?.packages?.length > 0) &&
              !currentShipper?.id ? (
                <Button.Primary
                  title={"Select Shipper to Checkout"}
                  className={"w-full h-[48px] px-4 mt-4"}
                  onClick={() => onOpenShipperModal && onOpenShipperModal()}
                />
              ) : isAuth ? (
                <>
                  {(myCart?.products?.length > 0 ||
                    myCart?.packages?.length > 0) &&
                    (currentAddress?.length > 0 ? (
                      <>
                        <Button.Primary
                          disabled={processing}
                          title={processing ? <Beat /> : "Place Order"}
                          className={"w-full h-[48px] px-4 mt-6 mb-2"}
                          onClick={() => handleSubmit()}
                        />

                        <Button.Secondary
                          title={loadingPfm ? <Beat /> : "Share Payment Link"}
                          className={"w-full h-[48px] px-4 mt-4 mb-2"}
                          onClick={() => handleSubmitShare()}
                        />
                      </>
                    ) : (
                      <Button.Primary
                        title={"Set address to checkout"}
                        className={"w-full h-[48px] px-4 mt-4"}
                        onClick={() => setOpen(true)}
                      />
                    ))}
                </>
              ) : (
                (myCart?.products?.length > 0 || myCart?.packages?.length > 0) && (
                  <div className="text-center mt-8">
                    <Button.Primary
                      title={"Login To Checkout"}
                      className="px-3 py-4 w-full"
                      onClick={openModal}
                    />
                    <Button.Secondary
                      title={"Check Out As Guest"}
                      className="px-3 py-4 w-full mt-5"
                      disabled={
                        !setShipper?.id ||
                        (!myCart?.products?.length && !myCart?.packages?.length)
                      }
                      onClick={() => goToGuestCheckout()}
                    />
                  </div>
                )
              )}

              {!isAuth ? (
                <SignUpModal
                  show={isOpen}
                  onClose={closeModal}
                  type={"checkout"}
                />
              ) : (
                currentAddress?.length < 1 && (
                  <AddressModal show={open} onClose={() => setOpen(false)} />
                )
              )}
            </div>
          </div>

          {/* Service area notice */}
          {/* <div className="mt-8 px-2 py-2 flex gap-3 items-center justify-center">
            <img
              onClick={() => setServiceNotice(true)}
              src={Warning}
              alt="warning"
              className="w-[18px] h-[18px] cursor-pointer"
            />
            <p className="text-sm text-[#333333] dark:text-[#BCBCBC] font-bold">
              Incorrect service area will result to additional charges...{" "}
              <span
                className="text-primary cursor-pointer"
                onClick={() => setServiceNotice(true)}
              >
                Learn more
              </span>
            </p>
          </div> */}

          {/* Pricing change notice */}
          {/* <div className="mt-5 px-2 flex gap-2 items-center">
            <img
              onClick={() => setOpenNotice(true)}
              src={Warning}
              alt="warning"
              className="w-[18px] h-[18px] cursor-pointer"
            />
            <p className="text-sm text-[#333333] dark:text-[#BCBCBC] font-bold">
              Final prices are subject to change...{" "}
              <span
                className="text-primary cursor-pointer"
                onClick={() => setOpenNotice(true)}
              >
                Learn more
              </span>
            </p>
          </div> */}
        </div>

        {/* Delivery Instructions */}
        {/* {isAuth && (
          <div className="mt-16">
            <div className="mb-4">
              <h3 className="text-xl font-medium mb-2">
                Add Delivery Details (optional)
              </h3>
              <p className="text-gray-400 dark:text-[#BCBCBC] text-[14px]">
                If you have any instruction for ogwugo, please let us know
                below.
              </p>
            </div>

            <div className="flex w-full gap-4 justify-between mb-3">
              <input
                type={"text"}
                placeholder="E.g door or apartment number..."
                onChange={(e) => handleChangeDeliveryNotes(e)}
                className=" flex-1 h-12 pl-3 pr-10 w-full rounded-lg text-base bg-[#FFFFFF] dark:bg-transparent focus:ring focus:ring-red-600 focus:border-red-600 focus:outline-none sm:text-sm px-4 py-2 border border-gray-300 "
              />
              <Button.Primary
                disabled={processing}
                title={"Add"}
                className={"w-fit h-12 px-4"}
                onClick={() => handleAddressDeliveryNotes()}
              />
            </div>
          </div>
        )} */}
      </section>
      <PaymentModalCart
        ref={paymentModalRef}
        payment_type={"standard"}
        visibility={false}
      />
      <ShareOrderModal
        ref={shareOrderModalRef}
        handleSubmit={handleSubmitShare}
      />

      {/* <PriceNoticeModal open={openNotice} setOpen={setOpenNotice} />
      <ServiceAreaNoticeModal open={serviceNotice} setOpen={setServiceNotice} /> */}
    </div>
  );
}
